import { setShelterName, setKojinInfo, setKojinInfoDetail, setSetaiInfo, setYearList } from './actions';
import config from './../../config/config.js';
import { push } from 'connected-react-router';
import axios from 'axios';


//個人情報取得
const getKojin = (knum, uuid, snum, flg) => {
  return async(dispatch, getState) => {

    console.log('------getKojin------');
    console.log('knum', knum);
    console.log('uuid', uuid);
    console.log('snum', snum);
    console.log('flg', flg);
    
    let url = "";
    let mode = "";

    //クエリー指定
    if ( flg === 'K' ) {
      url = config.API_MethodName_Evacuee;
      mode = '1';
    } else {
      url = config.API_MethodName_Evacuees;
      mode = '2';
    }

    console.log('mode', mode);

    const header = {'Access-Control-Allow-Origin' : "*"};

    const param = {
          'app' : config.Kintone_ApiId_Kojin,
          'totalCount' : 'true',
          'personalNumber': knum,
          'householdNumber': snum,
          'UUIDTextFiled': uuid,
          'mode': mode 
    };
    console.log('param', param);
    return await axios.get(url, {
        withCredentials: true,
        params: param
      });
  };
};


//世帯・個人情報登録
const setKojin = (count, getCnt) => {
  return async(dispatch, getState) => {

    console.log('------setKojin------');

    let state = getState();
    let values = state.form.Infoadd.values;
    let shelterName = state.infoadd.shelterName;

    console.log('state');
    console.log(state);
    console.log('values');
    console.log(values);
    console.log(count);

    let setaiRows  = [];
    let kojinRows  = [];
    let householdNumber = "";
    let personalNumber = "";
    let representative = "";
    let requests = [];
    
    //入所日時を設定
    //※Kintone側の仕様のため日本時間（JST）は＋9：00を設定する
    let arriveDate = new Date().getFullYear() + '-'
      + ('0' + (new Date().getMonth() +1)).slice(-2) + '-'
      + ('0' + new Date().getDate()).slice(-2) + 'T'
      + ('0' + new Date().getHours()).slice(-2) + ':'
      + ('0' + new Date().getMinutes()).slice(-2) + ':00+09:00';

    console.log("arriveDate", arriveDate);
    
    //世帯情報設定
    // 代表者フラグの立っているデータを取得
    let representativeData = state.infoadd.kojinInfo.find(v => v.representativeFlag === "1");
    console.log('代表者データ');
    console.log(representativeData);
    
    //世帯番号設定
    if ( getCnt === 0 ) {
      //新規登録の場合
      householdNumber = representativeData.personalNumber;
    } else {
      //追加の場合
      householdNumber = representativeData.householdNumber;
    };
    
    console.log("householdNumber:"+householdNumber);

    if ( getCnt === 0 ) {
      // 世帯情報パラメータの生成
      let row = {
          "place" : { "value" : shelterName },
          "householdNumber" : { "value" : String( householdNumber ) }
      };
      
      let setaiInfo = state.infoadd.setaiInfo;
    
      if (setaiInfo.districtName !== "" ){
          row.DistrictNameTextFiled = { "value" : setaiInfo.districtName };
      }
      if (setaiInfo.chonaikaiName !== "" ){
          row.ChonaikaiNameTextFiled = { "value" : setaiInfo.chonaikaiName };
      }
      if (setaiInfo.jichikaiName !== "" ){
          row.JichikaiNameTextFiled = { "value" : setaiInfo.jichikaiName };
      }
      if (setaiInfo.address !== "" ){
          row.AddressTextFiled = { "type" : "MULTI_LINE_TEXT", "value" : setaiInfo.address };
      }
      if (setaiInfo.personalNameEC !== "" ){
          row.PersonalNameECTextFiled = { "value" : setaiInfo.personalNameEC };
      }
      if (setaiInfo.addressEC !== "" ){
          row.AddressECTextFiled = { "type" : "MULTI_LINE_TEXT", "value" : setaiInfo.addressEC };
      }
      if (setaiInfo.numberEC !== "" ){
          row.NumberECTextFiled = { "value" : setaiInfo.numberEC };
      }
      if (setaiInfo.relationshipEC !== "" ){
          row.RelationshipECTextFiled = { "value" : setaiInfo.relationshipEC };
      }
      if (setaiInfo.representativeName !== "" ){
          row.RepresentativeNameTextFiled = { "value" : setaiInfo.representativeName };
      }
      if (setaiInfo.representativeHira !== "" ){
          row.RepresentativeHiraTextFiled = { "value" : setaiInfo.representativeHira };
      }
      if (setaiInfo.representativeKana !== "" ){
          row.RepresentativeKanaTextFiled = { "value" : setaiInfo.representativeKana };
      }
      if (setaiInfo.entryName !== "" ){
          row.EntryNameTextFiled = { "value" : setaiInfo.entryName };
      }
      if (setaiInfo.entryHira !== "" ){
          row.EntryHiraTextFiled = { "value" : setaiInfo.entryHira };
      }
      if (setaiInfo.entryKana !== "" ){
          row.EntryKanaTextFiled = { "value" : setaiInfo.entryKana };
      }
      if (setaiInfo.homePhoneNumber !== "" ){
          row.HomePhoneNumberTextFiled = { "value" : setaiInfo.homePhoneNumber };
      }
      if (setaiInfo.faxNumber !== "" ){
          row.FaxNumberTextFiled = { "value" : setaiInfo.faxNumber };
      }
      if (setaiInfo.evacuationType !== "" ){
          row.EvacuationTypeSelectBox = { "type" : "DROP_DOWN", "value" : setaiInfo.evacuationType };
      }
      if (setaiInfo.transportation !== "" ){
          row.TransportationSelectBox = { "type" : "DROP_DOWN", "value" : setaiInfo.transportation };
      }
      if (setaiInfo.otherTransportation !== "" ){
          row.OtherTransportationTextFiled = { "value" : setaiInfo.otherTransportation };
      }
      if (setaiInfo.cars !== "" ){
          row.CarsTextFiled = { "value" : setaiInfo.cars };
      }
      if (setaiInfo.carModel !== "" ){
          row.CarModelTextFiled = { "value" : setaiInfo.carModel };
      }
      if (setaiInfo.carColor !== "" ){
          row.CarColorTextFiled = { "value" : setaiInfo.carColor };
      }
      if (setaiInfo.carNumberPlate !== "" ){
          row.CarNumberPlateTextFiled = { "value" : setaiInfo.carNumberPlate };
      }
      if (setaiInfo.parking !== "" ){
          row.ParkingTextFiled = { "value" : setaiInfo.parking };
      }
      if (setaiInfo.pet !== "" ){
          row.PetSelectBox = { "type" : "DROP_DOWN", "value" : setaiInfo.pet };
      }
      if (setaiInfo.petState !== "" ){
          row.PetStateSelectBox = { "type" : "DROP_DOWN", "value" : setaiInfo.petState };
      }
      if (setaiInfo.houseDamage !== "" ){
          row.HouseDamageSelectBox = { "type" : "DROP_DOWN", "value" : setaiInfo.houseDamage };
      }
      if (setaiInfo.infraDamage.length !== 0){
          row.InfraDamageSelectBox = { "type" : "MULTI_SELECT", "value" : setaiInfo.infraDamage };
      }
      if (setaiInfo.otherDamage !== "" ){
          row.OtherDamageTextFiled = { "type" : "MULTI_LINE_TEXT", "value" : setaiInfo.otherDamage };
      }
      if (setaiInfo.citizen !== "" ){
          row.CitizenSelectBox = { "type" : "DROP_DOWN", "value" : setaiInfo.citizen };
      }
      if (setaiInfo.spare1R !== "" ){
          row.Spare1RTextFiled = { "type" : "MULTI_LINE_TEXT", "value" : setaiInfo.spare1R };
      }
      if (setaiInfo.spare2R !== "" ){
          row.Spare2RTextFiled = { "type" : "MULTI_LINE_TEXT", "value" : setaiInfo.spare2R };
      }
      if (setaiInfo.spare3R !== "" ){
          row.Spare3RTextFiled = { "type" : "MULTI_LINE_TEXT", "value" : setaiInfo.spare3R };
      }
      if (setaiInfo.spare4R !== "" ){
          row.Spare4RTextFiled = { "type" : "DROP_DOWN", "value" : setaiInfo.spare4R };
      }
      if (setaiInfo.spare5R !== "" ){
          row.Spare5RTextFiled = { "type" : "DROP_DOWN", "value" : setaiInfo.spare5R };
      }
      
      setaiRows.push(row);
      console.log(setaiRows);
    }

    let kojinInfo = state.infoadd.kojinInfo;
    console.log(kojinInfo);
    
    //個人情報設定
    for(var i=0; i<=count-1; i++){
      
      let kojinInfoValue = kojinInfo[i];
      console.log("param");
      console.log(kojinInfoValue);
      
      // 登録済みの個人は対象外とする
      if( kojinInfoValue.outFlag !== "1" ) {
        
        //個人番号を設定
        personalNumber = kojinInfoValue.personalNumber
        
        //個人番号が登録されているデータのみ
        if (personalNumber !== ""){ 
          console.log("personalNumber",personalNumber);
          
          // 代表者
          representative = "" ;
          if ( householdNumber === kojinInfoValue.personalNumber ) {
            representative = "代表者"
          };
          console.log("representative",representative);
          
          // 個人情報パラメータの生成
          let row = {
              "ShelterNameTextFiled" : { "value" : shelterName },
              "householdNumber" : { "value" : String( householdNumber ) },
              "personalNumber" : { "value" : String( personalNumber ) },
              "UUIDTextFiled" : { "value" : kojinInfoValue.uuid },
              "status" : { "value" : "入所中" },
              "AdmissionDataTextFiled" : { "value" : arriveDate }
          };
          
          if ( representative !== "" ){
            row.RepresentativeCheckBox = { "type" : "CHECK_BOX", "value" : [ representative ] };
          }
          if (kojinInfoValue.personalName !== "" ){
              row.PersonalNameTextFiled = { "value" : kojinInfoValue.personalName };
          }
          if (kojinInfoValue.personalHira !== "" ){
              row.PersonalHiraTextFiled = { "value" : kojinInfoValue.personalHira };
          }
          if (kojinInfoValue.personalKana !== "" ){
              row.PersonalKanaTextFiled = { "value" : kojinInfoValue.personalKana };
          }
          if (kojinInfoValue.gender !== "" ){
              row.GenderSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.gender };
          }
          if (kojinInfoValue.birthDateYear !== "" ){
              row.BirthDateYearSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.birthDateYear };
          }
          if (kojinInfoValue.birthDateMonth !== "" ){
              row.BirthDateMonthSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.birthDateMonth };
          }
          if (kojinInfoValue.birthDateDay !== "" ){
              row.BirthDateDaySelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.birthDateDay };
          }
          if (kojinInfoValue.age !== "" ){
              row.AgeTextFiled = { "value" : kojinInfoValue.age };
          }
          if (kojinInfoValue.telephoneNumber !== "" ){
              row.TelephoneNumberTextFiled = { "value" : kojinInfoValue.telephoneNumber };
          }
          if (kojinInfoValue.relationship !== "" ){
              row.RelationshipTextFiled = { "value" : kojinInfoValue.relationship };
          }
          if (kojinInfoValue.nationality !== "" ){
              row.NationalitySelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.nationality };
          }
          if (kojinInfoValue.otherNationality !== "" ){
              row.OtherNationalityTextFiled = { "value" : kojinInfoValue.otherNationality };
          }
          if (kojinInfoValue.language !== "" ){
              row.LanguageTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.language };
          }
          if (kojinInfoValue.evacuationForm !== "" ){
              row.EvacuationFormSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.evacuationForm };
          }
          if (kojinInfoValue.otherEvacuationForm !== "" ){
              row.OtherEvacuationFormTextFiled = { "value" : kojinInfoValue.otherEvacuationForm };
          }
          if (kojinInfoValue.place !== "" ){
              row.PlaceSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.place };
          }
          if (kojinInfoValue.otherPlace !== "" ){
              row.OtherPlaceTextFiled = { "value" : kojinInfoValue.otherPlace };
          }
          if (kojinInfoValue.foods !== "" ){
              row.FoodsSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.foods };
          }
          if (kojinInfoValue.otherFoods !== "" ){
              row.OtherFoodsTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.otherFoods };
          }
          if (kojinInfoValue.disease !== "" ){
              row.DiseaseTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.disease };
          }
          if (kojinInfoValue.injury !== "" ){
              row.InjuryTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.injury };
          }
          if (kojinInfoValue.shoniIryo !== "" ){
              row.ShoniIryoSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.shoniIryo };
          }
          if (kojinInfoValue.jinkoToseki !== "" ){
              row.JinkoTosekiSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.jinkoToseki };
          }
          if (kojinInfoValue.sansoRyoho !== "" ){
              row.SansoRyohoSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.sansoRyoho };
          }
          if (kojinInfoValue.fujinkaIryo !== "" ){
              row.FujinkaIryoSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.fujinkaIryo };
          }
          if (kojinInfoValue.seishinIryo !== "" ){
              row.SeishinIryoSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.seishinIryo };
          }
          if (kojinInfoValue.feverCough !== "" ){
              row.FeverCoughSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.feverCough };
          }
          if (kojinInfoValue.kaigo !== "" ){
              row.KaigoTextFiled = { "value" : kojinInfoValue.kaigo };
          }
          if (kojinInfoValue.deficiency !== "" ){
              row.DeficiencySelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.deficiency };
          }
          if (kojinInfoValue.risk !== "" ){
              row.RiskSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.risk };
          }
          if (kojinInfoValue.bloodType !== "" ){
              row.BloodTypeSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.bloodType };
          }
          if (kojinInfoValue.medicine !== "" ){
              row.MedicineSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.medicine };
          }
          if (kojinInfoValue.medicineName !== "" ){
              row.MedicineTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.medicineName };
          }
          if (kojinInfoValue.allergy !== "" ){
              row.AllergyTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.allergy };
          }
          if (kojinInfoValue.disabled !== "" ){
              row.DisabledTextFiled = { "value" : kojinInfoValue.disabled };
          }
          if (kojinInfoValue.iryokiki !== "" ){
              row.IryokikiSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.iryokiki };
          }
          if (kojinInfoValue.pregnancy !== "" ){
              row.PregnancySelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.pregnancy };
          }
          if (kojinInfoValue.child !== "" ){
              row.ChildSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.child };
          }
          if (kojinInfoValue.request !== "" ){
              row.RequestTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.request };
          }
          if (kojinInfoValue.cooperation.length !== 0 ){
              row.CooperationSelectBox = { "type" : "MULTI_SELECT", "value" : kojinInfoValue.cooperation };
          }
          if (kojinInfoValue.otherCooperation !== "" ){
              row.OtherCooperationTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.otherCooperation };
          }
          if (kojinInfoValue.free !== "" ){
              row.FreeTextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.free };
          }
          if (kojinInfoValue.information !== "" ){
              row.InformationSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.information };
          }
          if (kojinInfoValue.disclosure !== "" ){
              row.DisclosureSelectBox = { "type" : "DROP_DOWN", "value" : kojinInfoValue.disclosure };
          }
          if (kojinInfoValue.spare1 !== "" ){
              row.Spare1TextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.spare1 };
          }
          if (kojinInfoValue.spare2 !== "" ){
              row.Spare2TextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.spare2 };
          }
          if (kojinInfoValue.spare3 !== "" ){
              row.Spare3TextFiled = {"type" : "MULTI_LINE_TEXT", "value" : kojinInfoValue.spare3 };
          }
          if (kojinInfoValue.spare4 !== "" ){
              row.Spare4TextFiled = { "type" : "DROP_DOWN", "value" : kojinInfoValue.spare4 };
          }
          if (kojinInfoValue.spare5 !== "" ){
              row.Spare5TextFiled = { "type" : "DROP_DOWN", "value" : kojinInfoValue.spare5 };
          }
          
          console.log(i, row);
          
          kojinRows.push(row);
        }
      }
    }
    console.log(kojinRows);

    const header = {'Access-Control-Allow-Origin' : "*"};

    // kintone実行パラメータ生成
    if ( getCnt === 0 ) {
      var param = {
          'parameter': {
              'requests': [
                {
                  'method' : 'POST',
                  'api' : '/k/v1/record.json',
                  'payload': {
                    'app' : config.Kintone_ApiId_Setai,
                    'record' : setaiRows[0]
                  }
                },
                {
                  'method' : 'POST',
                  'api' : '/k/v1/records.json',
                  'payload': {
                    'app' : config.Kintone_ApiId_Kojin,
                    'records' : kojinRows
                  }
                }
              ]
          }
      };
    } else {
      var param = {
          'parameter': {
              'requests': [
                {
                  'method' : 'POST',
                  'api' : '/k/v1/records.json',
                  'payload': {
                    'app' : config.Kintone_ApiId_Kojin,
                    'records' : kojinRows
                  }
                }
              ]
          }
      };
    }

    console.log('param', param);
    return await axios.post(config.API_MethodName_Evacuees, param, {
      withCredentials: true
    });

   };
};

//年度セット
const setYearListOperation = () => {
  return async (dispatch, getState) => {
    
    console.log('------setYearOperation------');
    
    let startNum = 1900;
    let today = new Date();
    let endYear  = today.getFullYear();
    let value = [];
    let data = [
      [ '明治', 1868, 1912 ], // 明治45年
      [ '大正', 1912, 1926 ], // 大正15年
      [ '昭和', 1926, 1989 ], // 昭和64年
      [ '平成', 1989, 2019 ], // 平成31年
      [ '令和', 2019, 9999 ], 
    ];
    
    for (let year = startNum; year <= endYear ; year++) {
      let yearName='';
      // 元号を取得する
      for (let item of data) {
        if ( item[1] <= year && year<= item[2] ){
          if(yearName===''){
            yearName += item[0]+(year-item[1]+1)
          } else {
            yearName += '/'+item[0]+'元'
          };
        };
      };
      value.push({key: year, value: year+' ('+yearName+')'});
    };
    
    dispatch(setYearList(value));
  };
};

//避難所名セット
const setShelterNameOperation = (value) => {
  return async (dispatch, getState) => {
    
    console.log(value);

    dispatch(setShelterName(value));
  };
};

//世帯情報リセット
const resetSetaiInfoOperation = (infraDamage) => {
  return async (dispatch, getState) => {
    
    console.log('------resetSetaiInfoOperation------');
    const param = {
      districtName:"",
      chonaikaiName:"",
      jichikaiName:"",
      address:"",
      personalNameEC:"",
      addressEC:"",
      numberEC:"",
      relationshipEC:"",
      representativeName:"",
      representativeHira:"",
      representativeKana:"",
      entryName:"",
      entryHira:"",
      entryKana:"",
      homePhoneNumber:"",
      faxNumber:"",
      evacuationType:"",
      transportation:"",
      otherTransportation:"",
      cars:"",
      carModel:"",
      carColor:"",
      carNumberPlate:"",
      parking:"",
      pet:"",
      petState:"",
      houseDamage:"",
      infraDamage:[],
      otherDamage:"",
      citizen:"",
      spare1R:"",
      spare2R:"",
      spare3R:"",
      spare4R:"",
      spare5R:"",
    }
    
    dispatch(setSetaiInfo(param));
  };
};

//世帯情報セット
const setSetaiInfoOperation = (infraDamage) => {
  return async (dispatch, getState) => {
    
    console.log('------setSetaiInfoOperation------');
    let state = getState();
    console.log(state);
    
    let values = state.form.Infoadd.values;
    console.log(values);
    
    const param = {
      districtName:values.DistrictNameTextFiled,
      chonaikaiName:values.ChonaikaiNameTextFiled,
      jichikaiName:values.JichikaiNameTextFiled,
      address:values.AddressTextFiled,
      personalNameEC:values.PersonalNameECTextFiled,
      addressEC:values.AddressECTextFiled,
      numberEC:values.NumberECTextFiled,
      relationshipEC:values.RelationshipECTextFiled,
      representativeName:values.RepresentativeNameTextFiled,
      representativeHira:values.RepresentativeHiraTextFiled,
      representativeKana:values.RepresentativeKanaTextFiled,
      entryName:values.EntryNameTextFiled,
      entryHira:values.EntryHiraTextFiled,
      entryKana:values.EntryKanaTextFiled,
      homePhoneNumber:values.HomePhoneNumberTextFiled,
      faxNumber:values.FaxNumberTextFiled,
      evacuationType:values.EvacuationTypeSelectBox,
      transportation:values.TransportationSelectBox,
      otherTransportation:values.OtherTransportationTextFiled,
      cars:values.CarsTextFiled,
      carModel:values.CarModelTextFiled,
      carColor:values.CarColorTextFiled,
      carNumberPlate:values.CarNumberPlateTextFiled,
      parking:values.ParkingTextFiled,
      pet:values.PetSelectBox,
      petState:values.PetStateSelectBox,
      houseDamage:values.HouseDamageSelectBox,
      infraDamage:infraDamage,
      otherDamage:values.OtherDamageTextFiled,
      citizen:values.CitizenSelectBox,
      spare1R:values.Spare1RTextFiled,
      spare2R:values.Spare2RTextFiled,
      spare3R:values.Spare3RTextFiled,
      spare4R:values.Spare4RTextFiled,
      spare5R:values.Spare5RTextFiled,
    }
    
    dispatch(setSetaiInfo(param));
  };
};

//個人情報追加 
const setKojinInfoOperation = (idx) => {
  return async (dispatch, getState) => {
    
    console.log('------setKojinInfoOperation------');
    let state = getState();
    console.log(state);
    
    let values = state.form.Infoadd.values;
    console.log(values);
    
    let list = [];
    
    const param = {
      idx:idx,
      personalNumber:"",
      uuid:"",
      householdNumber:"",
      personalName:"",
      personalHira:"",
      personalKana:"",
      gender:"",
      birthDate:"",
      birthDateYear:"",
      birthDateMonth:"",
      birthDateDay:"",
      age:"",
      telephoneNumber:"",
      relationship:"",
      nationality:"",
      otherNationality:"",
      language:"",
      evacuationForm:"",
      otherEvacuationForm:"",
      place:"",
      otherPlace:"",
      foods:"",
      otherFoods:"",
      disease:"",
      injury:"",
      shoniIryo:"",
      jinkoToseki:"",
      sansoRyoho:"",
      fujinkaIryo:"",
      seishinIryo:"",
      feverCough:"",
      kaigo:"",
      deficiency:"",
      risk:"",
      bloodType:"",
      medicine:"",
      medicineName:"",
      allergy:"",
      disabled:"",
      iryokiki:"",
      pregnancy:"",
      child:"",
      request:"",
      cooperation:[],
      otherCooperation:"",
      free:"",
      information:"",
      disclosure:"",
      spare1:"",
      spare2:"",
      spare3:"",
      spare4:"",
      spare5:"",
      status:"",
      outFlag:"0",
      representativeFlag:"0"
    }
    
    list = state.infoadd.kojinInfo;
    console.log(list)
    list[idx]=param;
    
    dispatch(setKojinInfo(list));
  };
};

//個人情報削除 
const deleteKojinInfoOperation = (idx) => {
  
  return async (dispatch, getState) => {
    
    console.log('------deleteKojinInfoOperation------');
    let state = getState();
    console.log(state);
    
    let values = state.form.Infoadd.values;
    console.log(values);
    
    let list = [];
    list = state.infoadd.kojinInfo;
    console.log(idx);
    list.splice(idx, 1);
    
    dispatch(setKojinInfo(list));
  };
  
};

//個人番号追加
const setKojinNumberOperation = (idx,personalNumber,UUID) => {
  return async (dispatch, getState) => {
    
    console.log('------setKojinNumberOperation------');
    let state = getState();
    console.log(state);
    
    let values = state.form.Infoadd.values;
    console.log(values);
    
    let list = [];
    
    const param = {
      idx:idx,
      personalNumber:personalNumber,
      uuid:UUID,
      householdNumber:"",
      personalName:"",
      personalHira:"",
      personalKana:"",
      gender:"",
      birthDate:"",
      birthDateYear:"",
      birthDateMonth:"",
      birthDateDay:"",
      age:"",
      telephoneNumber:"",
      relationship:"",
      nationality:"",
      otherNationality:"",
      language:"",
      evacuationForm:"",
      otherEvacuationForm:"",
      place:"",
      otherPlace:"",
      foods:"",
      otherFoods:"",
      disease:"",
      injury:"",
      shoniIryo:"",
      jinkoToseki:"",
      sansoRyoho:"",
      fujinkaIryo:"",
      seishinIryo:"",
      feverCough:"",
      kaigo:"",
      deficiency:"",
      risk:"",
      bloodType:"",
      medicine:"",
      medicineName:"",
      allergy:"",
      disabled:"",
      iryokiki:"",
      pregnancy:"",
      child:"",
      request:"",
      cooperation:[],
      otherCooperation:"",
      free:"",
      information:"",
      disclosure:"",
      spare1:"",
      spare2:"",
      spare3:"",
      spare4:"",
      spare5:"",
      status:"入所中",
      outFlag:"0",
      representativeFlag:"0"
    }
    
    list = state.infoadd.kojinInfo;
    list[idx-1]=param;
    
    dispatch(setKojinInfo(list));
  };
};

//個人情報セット
const setKojinInfoListOperation = (cooperation) => {
  return async (dispatch, getState) => {
    
    console.log('------setKojinInfoListOperation------');
    let state = getState();
    console.log(state);
    
    let values = state.form.Infoadd.values;
    console.log(values);
    
    let list = [];
    
    list = state.infoadd.kojinInfo;
    
    let deatail = state.infoadd.kojinInfoDetail;
    
    const param = {
      idx:deatail.idx,
      personalNumber:deatail.personalNumber,
      uuid:deatail.uuid,
      householdNumber:"",
      personalName:values.PersonalNameTextFiled,
      personalHira:values.PersonalHiraTextFiled,
      personalKana:values.PersonalKanaTextFiled,
      gender:values.GenderSelectBox,
      birthDateYear:values.BirthDateYearSelectBox,
      birthDateMonth:values.BirthDateMonthSelectBox,
      birthDateDay:values.BirthDateDaySelectBox,
      age:values.AgeTextFiled,
      telephoneNumber:values.TelephoneNumberTextFiled,
      relationship:values.RelationshipTextFiled,
      nationality:values.NationalitySelectBox,
      otherNationality:values.OtherNationalityTextFiled,
      language:values.LanguageTextFiled,
      evacuationForm:values.EvacuationFormSelectBox,
      otherEvacuationForm:values.OtherEvacuationFormTextFiled,
      place:values.PlaceSelectBox,
      otherPlace:values.OtherPlaceTextFiled,
      foods:values.FoodsSelectBox,
      otherFoods:values.OtherFoodsTextFiled,
      disease:values.DiseaseTextFiled,
      injury:values.InjuryTextFiled,
      shoniIryo:values.ShoniIryoSelectBox,
      jinkoToseki:values.JinkoTosekiSelectBox,
      sansoRyoho:values.SansoRyohoSelectBox,
      fujinkaIryo:values.FujinkaIryoSelectBox,
      seishinIryo:values.SeishinIryoSelectBox,
      feverCough:values.FeverCoughSelectBox,
      kaigo:values.KaigoTextFiled,
      deficiency:values.DeficiencySelectBox,
      risk:values.RiskSelectBox,
      bloodType:values.BloodTypeSelectBox,
      medicine:values.MedicineSelectBox,
      medicineName:values.MedicineTextFiled,
      allergy:values.AllergyTextFiled,
      disabled:values.DisabledTextFiled,
      iryokiki:values.IryokikiSelectBox,
      pregnancy:values.PregnancySelectBox,
      child:values.ChildSelectBox,
      request:values.RequestTextFiled,
      cooperation:cooperation,
      otherCooperation:values.OtherCooperationTextFiled,
      free:values.FreeTextFiled,
      information:values.InformationSelectBox,
      disclosure:values.DisclosureSelectBox,
      spare1:values.Spare1TextFiled,
      spare2:values.Spare2TextFiled,
      spare3:values.Spare3TextFiled,
      spare4:values.Spare4TextFiled,
      spare5:values.Spare5TextFiled,
      status:deatail.status,
      outFlag:deatail.outFlag,
      representativeFlag:deatail.representativeFlag
    }
    
    list[deatail.idx-1]=param;
    
    dispatch(setKojinInfo(list));
  };
};

//登録済み個人情報storeセット
const setRegisteredKojinInfoListOperation = (idx,values) => {
  return async (dispatch, getState) => {
    
    console.log('------setRegisteredKojinInfoListOperation------');
    console.log(values);
    let state = getState();
    console.log(state);
    
    let list = [];
    
    const param = {
      idx:idx,
      personalNumber:values.personalNumber.value,
      uuid:values.UUIDTextFiled.value,
      householdNumber:values.householdNumber.value,
      personalName:values.PersonalNameTextFiled.value,
      personalHira:values.PersonalHiraTextFiled.value,
      personalKana:values.PersonalKanaTextFiled.value,
      gender:values.GenderSelectBox.value,
      birthDateYear:values.BirthDateYearSelectBox.value,
      birthDateMonth:values.BirthDateMonthSelectBox.value,
      birthDateDay:values.BirthDateDaySelectBox.value,
      age:values.AgeTextFiled.value,
      telephoneNumber:values.TelephoneNumberTextFiled.value,
      relationship:values.RelationshipTextFiled.value,
      nationality:values.NationalitySelectBox.value,
      otherNationality:values.OtherNationalityTextFiled.value,
      language:values.LanguageTextFiled.value,
      evacuationForm:values.EvacuationFormSelectBox.value,
      otherEvacuationForm:values.OtherEvacuationFormTextFiled.value,
      place:values.PlaceSelectBox.value,
      otherPlace:values.OtherPlaceTextFiled.value,
      foods:values.FoodsSelectBox.value,
      otherFoods:values.OtherFoodsTextFiled.value,
      disease:values.DiseaseTextFiled.value,
      injury:values.InjuryTextFiled.value,
      shoniIryo:values.ShoniIryoSelectBox.value,
      jinkoToseki:values.JinkoTosekiSelectBox.value,
      sansoRyoho:values.SansoRyohoSelectBox.value,
      fujinkaIryo:values.FujinkaIryoSelectBox.value,
      seishinIryo:values.SeishinIryoSelectBox.value,
      feverCough:values.FeverCoughSelectBox.value,
      kaigo:values.KaigoTextFiled.value,
      deficiency:values.DeficiencySelectBox.value,
      risk:values.RiskSelectBox.value,
      bloodType:values.BloodTypeSelectBox.value,
      medicine:values.MedicineSelectBox.value,
      medicineName:values.MedicineTextFiled.value,
      allergy:values.AllergyTextFiled.value,
      disabled:values.DisabledTextFiled.value,
      iryokiki:values.IryokikiSelectBox.value,
      pregnancy:values.PregnancySelectBox.value,
      child:values.ChildSelectBox.value,
      request:values.RequestTextFiled.value,
      cooperation:values.CooperationSelectBox.value,
      otherCooperation:values.OtherCooperationTextFiled.value,
      free:values.FreeTextFiled.value,
      information:values.InformationSelectBox.value,
      disclosure:values.DisclosureSelectBox.value,
      spare1:values.Spare1TextFiled.value,
      spare2:values.Spare2TextFiled.value,
      spare3:values.Spare3TextFiled.value,
      spare4:values.Spare4TextFiled.value,
      spare5:values.Spare5TextFiled.value,
      status:values.status.value,
      outFlag:"1",
    }
    if (values.RepresentativeCheckBox.value == "代表者"){
      param.representativeFlag = "1"
    } else {
      param.representativeFlag = "0"
    }
    
    console.log(idx);
    console.log(param);
    
    list = state.infoadd.kojinInfo;
    list[idx-1]=param;
    
    dispatch(setKojinInfo(list));
  };
};

//個人情報モーダル　個人情報詳細セット
const setKojinInfoDetailOperation = (values) => {
  return async (dispatch, getState) => {
    
    console.log(values);
    console.log('------setKojinInfoDetailOperation------');
    dispatch(setKojinInfoDetail(values));
  };
};

//個人情報リセット
const resetKojinInfoListOperation = () => {
  return async (dispatch, getState) => {
    
    let list = [];
    console.log('------resetKojinInfoListOperation------');
    dispatch(setKojinInfo(list));
  };
};

export default {
  setYearListOperation,
  setShelterNameOperation,
  setSetaiInfoOperation,
  resetSetaiInfoOperation,
  setKojinInfoOperation,
  setKojinNumberOperation,
  setKojinInfoListOperation,
  setKojinInfoDetailOperation,
  setRegisteredKojinInfoListOperation,
  resetKojinInfoListOperation,
  deleteKojinInfoOperation,
  getKojin,
  setKojin
};
